import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import $ from "jquery";
import "./App.css";

import { UserProvider } from "./context/UserContext";
import PrivateRoute from './components/PrivateRoute';
import AuthLayout from "./layouts/AuthLayout";
import MainLayout from "./layouts/MainLayout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Home from "./pages/Home";
import ForgotPassword from "./pages/ForgotPassword";

/**
* Job Seeker Portal Imports
*/
import JSDashboard from "./pages/JSDashboard";
import JSSearch from "./pages/jobseeker/search";
import JSSAdvancedSearch from "./pages/jobseeker/AdvancedSearch";
import JSRecommendedJobs from "./pages/jobseeker/RecommendedJobs";
import JSMyApplications from "./pages/jobseeker/MyApplications";
import JSApplicationStatus from "./pages/jobseeker/ApplicationStatus";
import JSSavedJobs from "./pages/jobseeker/SavedJobs";
import JSJobAlerts from "./pages/jobseeker/JobAlerts";
import JobSeekerProfile from "./pages/jobseeker/JobSeekerProfile";

/**
* Employer Portal Routes
*/
import ManageJobs from "./pages/employer/jobManagement/ManageJobs";
import JobForm from "./components/employer/JobForm";
import CompanyProfile from "./pages/employer/companyProfile/CompanyInfo";
import CompanyProfileForm from "./components/company/CompanyProfileForm";
import EmployerProfile from "./pages/employer/EmployerProfile";
import EmployerProfileForm from "./components/employer/EmployerProfileForm";
import EmployerCandiateApplications from "./pages/employer/applications/CandidateApplications";
import EmployerCandiateJobApplications from "./pages/employer/applications/CandidateJobApplications";

/**
* ADMIN PORTAL Imports
*/
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminJobsManagement from "./pages/admin/JobsManagement";
import AdminEmployersManagement from "./pages/admin/EmployersManagement";
import AdminJobSeekersManagement from "./pages/admin/JobSeekersManagement";
import AdminApprovalsKYC from "./pages/admin/ApprovalsKYC";
import AdminReports from "./pages/admin/AdminReports";
import AdminAnalytics from "./pages/admin/AdminAnalytics";



function ProtectedHome() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedRole = localStorage.getItem("play");
    setRole(storedRole);
  }, []);

  if (!role) {
    // prevents blank screen on first render
    return <div>Loading...</div>;
  }

  if (role === "jobSeeker") {
    return <JSDashboard />;
  }

  if (role === "Admin") {
    return <AdminDashboard />;
  }

  if (role === "employer") {
    return <Home />;
  }

  return null;
}


function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = process.env.PUBLIC_URL + "/assets/js/custom.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up when component unmounts
    };
  }, []);

  return (
    <UserProvider> 
      <Router>
        <Routes>
          {/* Public Route: Login Page */}
          <Route path="/" element={
            <AuthLayout>
              <Login />
            </AuthLayout>
          } />
          {/* New Signup Route (Public) */}
          <Route path="/signup" element={
            <AuthLayout>
              <Signup />
            </AuthLayout>
          } />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected Routes */}
          <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>            
            <Route path="/home" element={<ProtectedHome />} />
            {/* JOB SEEKER PORTAL - Routes */}
            <Route path="/search" element={<JSSearch />} />
            <Route path="/advanced-search" element={<JSSAdvancedSearch />} />
            <Route path="/recommended-jobs" element={<JSRecommendedJobs />} />
            <Route path="/my-applications" element={<JSMyApplications />} />
            <Route path="/application-status" element={<JSApplicationStatus />} />
            <Route path="/saved-jobs" element={<JSSavedJobs />} />
            <Route path="/job-alerts" element={<JSJobAlerts />} />
            <Route path="/candidate/candidate-profile/profile" element={<JobSeekerProfile />} />
            <Route path="/candidate/profile-management/edit/:id" element={<EmployerProfileForm isEdit={true} />} />

            {/* EMPLOYER PORTAL - Routes */}
            {/* Employer - Company */}
            <Route path="/company/company-profile/profile" element={<CompanyProfile />} />
            <Route path="/company/profile-management/edit/:id" element={<CompanyProfileForm isEdit={true} />} />
            {/* Employer - Job Management Menu  */}
            <Route path="/employer/job-management/all-jobs" element={<ManageJobs />} />
            <Route path="/employer/job-management/your-jobs" element={<ManageJobs />} />
            <Route path="/employer/job-management/new" element={<JobForm isEdit={false} />} />
            <Route path="/employer/job-management/edit/:id" element={<JobForm isEdit={true} />} />
            {/* Employer - Applications */}
            <Route path="/employer/applications/view" element={<EmployerCandiateApplications />} />
            <Route path="/employer/view-applicant/jobs/:seeker_id" element = {<EmployerCandiateJobApplications />} />          
            {/* Employer - Profile Management */}
            <Route path="/employer/employer-profile/profile" element={<EmployerProfile />} />
            <Route path="/employer/profile-management/edit/:id" element={<EmployerProfileForm isEdit={true} />} />
            

            {/* ADMIN PORTAL - Routes */}
            <Route path="/admin/jobs" element={<AdminJobsManagement />} />
            <Route path="/admin/employers" element={<AdminEmployersManagement />} />
            <Route path="/admin/candidates" element={<AdminJobSeekersManagement />} />
            <Route path="/admin/approvals" element={<AdminApprovalsKYC />} />
            <Route path="/admin/reports" element={<AdminReports />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            {/* Add more protected routes here */}
          </Route>
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
